import { AutoComplete, Col, PageHeader, Row, Input, Tag } from 'antd';
import React, { ReactElement, useState } from 'react';
import { useHistory } from 'react-router-dom';
import useFetch from '../hooks/fetcher';
const API_SERVICE_BASE_URL = process.env.REACT_APP_API_SERVICE_BASE_URL || '';

type fetchResultType = {
    data: uniprotType[];
    count: number;
};

type uniprotType = {
    protein: string;
    gene: string;
    uniprot_entry: string;
    kegg_id: string;
};

type optionType = {
    label: string;
    options: {
        value: string;
        label: ReactElement;
        key: string;
    }[];
};

const renderItem = (
    key: string,
    title: string,
    label1: string,
    label2: string,
    label3: string,
): { value: string; key: string; label: ReactElement } => ({
    value: title,
    key: key,
    label: (
        <div>
            <div>{title}</div>
            <div>
                <Tag color="blue">{label1}</Tag>
                <Tag color="blue">{label2}</Tag>
                <Tag color="blue">{label3}</Tag>
            </div>
        </div>
    ),
});

const updateOptions = (data: fetchResultType, keyword: string): optionType[] => {
    const entries = data.data;
    const count = data.count;
    return [
        {
            label: 'Targets ' + count,
            options: entries.map((e, i) => renderItem(e.uniprot_entry, e.protein, e.gene, e.uniprot_entry, e.kegg_id)),
        },
    ];
};

const PageTarget: React.FC = () => {
    const { get } = useFetch(API_SERVICE_BASE_URL);
    const [options, setOptions] = useState<optionType[]>([]);
    const history = useHistory();
    const gutterH = 16;
    const gutterV = 16;
    const colHelperProps = {
        xs: 0,
        sm: 0,
        md: 2,
        lg: 5,
        xl: 7,
    };
    const colContentProps = {
        xs: 24,
        sm: 24,
        md: 20,
        lg: 14,
        xl: 10,
    };

    // choose one of the results
    const onSelect = (e: string, opt: any): void => {
        history.push(`/target/${opt.key}`);
    };

    // onChange event
    const onSearch = (e: string): Promise<void> =>
        get('/api/target_idx.php', { name: e }).then((r: fetchResultType) => setOptions(updateOptions(r, e)));

    return (
        <div>
            <PageHeader title="Target search" style={{ marginBottom: '10vh' }} />
            <Row justify="space-between" gutter={[gutterH, gutterV]}>
                <Col {...colHelperProps}></Col>
                <Col {...colContentProps} style={{ display: 'flex' }}>
                    <AutoComplete style={{ flex: 1 }} options={options} onSelect={onSelect} onSearch={onSearch}>
                        <Input.Search size="large" placeholder="Search target" />
                    </AutoComplete>
                </Col>
                <Col {...colHelperProps}></Col>
            </Row>

            <Row gutter={[gutterH, gutterV]}>
                <Col {...colHelperProps}></Col>
                <Col {...colContentProps}>
                    <div>
                        <br />
                        <strong>Examples:</strong>
                        <br />
                        Protein Name:<strong> Thrombin</strong>
                        <br />
                        Gene Name:<strong> F2</strong>
                        <br />
                        UniProt Entry:<strong> P00734</strong>
                        <br />
                        KEGG ID:<strong> hsa:2147</strong>
                        <br />
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default PageTarget;
